import { useContext } from "react";

import { useTranslation } from "react-i18next";

import Button, {
    BUTTON_COLORS,
    BUTTON_SIZES,
    BUTTON_VARIANTS
} from "components/DesignComponents/Button";
import ActionToolbarButtonWrapper from "components/DesignComponents/Button/ActionToolbarButtonWrapper";
import AuthContext from "context/auth/authContext";
import ParamsContext from "context/params/paramsContext";
import TableContext from "context/table/tableContext";
import { isInternalTypeCompany, useMediaQueries, usePermissions } from "shared";

import InviteUser from "../dialogs/Users/InviteUser";
import { USER_ACTIONS } from "../types";
import ContentFrame from "./components/ContentFrame";
import { useDialog } from "./hooks";

const UsersBar = () => {
    const { rootCompanyType, canInviteUsers } = useContext(ParamsContext);
    const { isAdminManagerUser } = useContext(AuthContext);
    const { isInitialLoading } = useContext(TableContext);

    const { t } = useTranslation();
    const { toSm } = useMediaQueries();
    const { isOpenDialog, openDialog, closeDialog } = useDialog();

    const { isCreateUserNotAllowed, isReadRoleNotAllowed, PERMISSIONS } =
        usePermissions();

    const isRootInternalTypeCompany = isInternalTypeCompany(rootCompanyType);

    const isDisabled = () => {
        if (isRootInternalTypeCompany) {
            return !isAdminManagerUser || isCreateUserNotAllowed;
        }

        return isCreateUserNotAllowed || isReadRoleNotAllowed;
    };

    return (
        <>
            <ContentFrame>
                {canInviteUsers && (
                    <ActionToolbarButtonWrapper
                        customTooltipTitle={
                            isRootInternalTypeCompany && !isAdminManagerUser
                                ? t("Button##invite user to internal disabled")
                                : undefined
                        }
                        permissionName={[
                            PERMISSIONS.UserCreate,
                            ...(isRootInternalTypeCompany
                                ? []
                                : [PERMISSIONS.RoleRead])
                        ]}
                    >
                        <Button
                            fullWidth={toSm}
                            hasRectangleLoader={toSm && isInitialLoading}
                            variant={BUTTON_VARIANTS.TextOnly}
                            size={BUTTON_SIZES.Small}
                            color={BUTTON_COLORS.Primary}
                            disabled={isDisabled()}
                            onClick={() => openDialog(USER_ACTIONS.InviteUser)}
                        >
                            {t("Button##invite user")}
                        </Button>
                    </ActionToolbarButtonWrapper>
                )}
            </ContentFrame>

            {canInviteUsers && (
                <InviteUser
                    isOpen={isOpenDialog[USER_ACTIONS.InviteUser]}
                    close={closeDialog}
                />
            )}
        </>
    );
};

export default UsersBar;
